module.exports = __webpack_public_path__ + "media/search/land_grayscale-74b59f87.png";